import './payment-list/payment-list.component';
import './payment-list/payment-list.scss';

import './payment-list-item/payment-list-item.component';
import './payment-list-item/payment-list-item.scss';
